import { useState, useEffect, useContext } from "react";
import "./ShopItem.scss";
import Drawer from "../drawer/Drawer";
import AddressItem from "../kits/addressListItem/AddressItem";
import AuthenticationContext from "../../context/Authentication/AuthenticationContext";
import { NavLink } from "react-router-dom";
import ShopItem from "./ShopItem.jsx";
import { AddIcon } from "../kits/Icons/Icons";
import { CustomInput } from "../kits/inputs/Input";
import useAxios from "../../services/useAxios";
import Add from "../../pages/AddressManage/Add";
import img1 from "../../assets/images/img1.jpg";
import s1 from "../../assets/images/slider/01.jpg";
import s2 from "../../assets/images/slider/02.jpg";
import s3 from "../../assets/images/slider/03.jpg";

import {
  ArrowDownIcon,
  SabadiIcon,
  HeadphoneIcon,
  CloseIcon,
} from "../kits/Icons/Icons.tsx";
import { IoIosCall } from "react-icons/io";
import CustomButton from "../kits/custom-button/CustomButton.tsx";

import WithLogin from "../../hoc/WithLogin.tsx";
import useWindowSize from "../../hooks/useWindowSize.jsx";
import colorsSchema from "../../assets/kits/colors";
import gv from "../../assets/kits/global-variables.module.scss";
import Loader from "../kits/Loader";
import WithSearch from "../../hoc/WithSearch";
import { pathMaker } from "../../utilities/helperFunctions";
import whitebg from "../../assets/images/defaultCover/whitebg.png";
import defaultCover from "../../assets/images/defaultCover/defaultCoverProduct.png";
import { TimeStampToJalali } from "../../utilities/helperFunctions";
import { DateObject } from "react-multi-date-picker";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";
import { MDBCarousel, MDBCarouselItem } from "mdb-react-ui-kit";
import { getBoxByPosition } from "../../utilities/apiTools";
import BoxSlider from "../common/slider/BoxSlider";

export default function ShopList() {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [slideImg, setSlideImg] = useState([
    // { img: s1, title: "" },
    // { img: s2, title: "" },
    // { img: s3, title: "" }
  ]);
  const winWidth = useWindowSize();
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [height, setHeight] = useState(627);
  const [selectedId, setSelectedId] = useState("");
  const [updaterAddress, setUpdaterAddress] = useState(false);
  const { execute: EditAddressApi } = useAxios("api/default_address");
  const { loading, execute: getSupplier } = useAxios(
    "superadminapi/getsuppliers"
  );
  const { execute: getCats } = useAxios("api/get_cats");
  const { execute: getOrders } = useAxios("api/get_order");
  const { execute: coversApi } = useAxios("superadminapi/covers");

  const auth = useContext(AuthenticationContext);
  const [shopItem, setShopItem] = useState([
    // {
    //   shopId: "",
    //   shopName: "سوپرمارکت ایکس",
    //   shopImage: img1,
    //   time: false,
    //   delivery: "14000"
    // }
  ]);
  const [shopItemOk, setShopItemOk] = useState([]);
  const [shopItemNok, setShopItemNok] = useState([]);
  const [defaultAddress, setDefaultAddress] = useState([]);
  const [titleData, setTitleData] = useState("");
  const [titleError, setTitleError] = useState("");
  const [cats, setCats] = useState([]);
  const [selectedCat, setSelectedCat] = useState("");
  const [updater, setUpdater] = useState(false);
  const [loadImg, setLoadImg] = useState(true);
  const [allDiv, setAllDiv] = useState([]);
  const [heightDiv, setHeightDiv] = useState(0);
  const [orders, setOrders] = useState([]);
  let nowHour = new Date().getHours();
  let nowMin = new Date().getMinutes();

  const updateAddress = () => {
    setUpdaterAddress((prev) => !prev);
  };

  function checkDefaultAddress() {
    setDefaultAddress(
      auth.userInfo.addresses?.filter(
        (a) => a.is_default == 1 && a.status != -1
      )
    );
  }

  async function EditAddressFunc(id) {
    await EditAddressApi({
      addressId: id,
    }).then((res) => {
      if (res.status == 1) {
        auth.refreshAddresses().finally(() => {
          setUpdater(!updater);
        });
      }
    });
  }

  useEffect(() => {
    allDiv.length != 0 && setHeightDiv(allDiv[2].offsetHeight);
    setIsOpen(false);
    let array = auth.userInfo.addresses.filter(
      (a) => a.is_default == 1 && a.status != -1
    );
    if (array.length > 0) {
      setSelectedId(array[0]["id"]);
    }
    getSupplier({ cat_id: 7 }).then((data) => {
      let x = [...data.data];
      let tmpNok = [];
      let tmpOk = [];
      for (let i = 0; i < x.length; i++) {
        console.log(
          "title",
          x[i].info.title,
          "start",
          x[i].info.start_hour,
          " ",
          x[i].info.start_min,
          "finish",
          x[i].info.finish_hour,
          " ",
          x[i].info.finish_min,
          nowMin
        );

        if (
          x[i].info.main_status == "0" &&
          x[i].inventory >= 1 &&
          (x[i].info.start_hour == "" ||
            x[i].info.finish_hour == "" ||
            (nowHour > x[i].info.start_hour &&
              nowHour < x[i].info.finish_hour) ||
            (nowHour == x[i].info.start_hour && nowMin > x[i].info.start_min) ||
            (nowHour == x[i].info.finish_hour && nowMin < x[i].info.finish_min))
        ) {
          tmpOk.push(x[i]);
        } else {
          tmpNok.push(x[i]);
        }
      }

      setShopItemNok(tmpNok);
      setShopItemOk(tmpOk);
      console.log("okkkk", shopItemOk);
      console.log("NNNNNokkkk", shopItemNok);
    });

    setSelectedCat("7");

    getOrders().then((data) => {
      setOrders(
        data?.orders?.successful?.filter(
          (value) => value.lats_order_status == "2"
        )
      );
    });
    checkDefaultAddress();
    // getCats().then(data => {
    //   setCats(
    //     data.cats
    //       .sort((value1, value2) => {
    //         return value1.sort - value2.sort;
    //       })
    //       .reverse()
    //   );
    // });

    coversApi().then((data) => {
      setSlideImg(data.files);
    });
  }, [auth.isLogin, updater, allDiv, updaterAddress]);
  const changeCat = (index) => {
    getSupplier({ isSuperAdmin: true, cat_id: index }).then((data) => {
      let x = [...data.data];

      let tmpNok = [];
      let tmpOk = [];
      for (let i = 0; i < x.length; i++) {
        if (
          x[i].info.main_status == "0" &&
          +x[i].inventory >= 1 &&
          nowHour > x[i].info.start_hour &&
          nowHour < x[i].info.finish_hour
        ) {
          tmpOk.push(x[i]);
        } else {
          tmpNok.push(x[i]);
        }
      }
      setShopItemNok(tmpNok);
      setShopItemOk(tmpOk);
      console.log("ok", shopItemOk);
      console.log("nnnok", shopItemNok);

      setSelectedCat(index);
    });
  };

  const [isOpenCall, setIsOpenCall] = useState(false);
  const supportCalls = () => {
    if (
      window.navigator.userAgent.indexOf("Windows") != -1 ||
      window.navigator.userAgent.indexOf("X11") != -1
    ) {
      return (
        <div>
          <div
            className="call pd-12 "
            style={{
              cursor: "pointer",
              left:
                winWidth.width > 600
                  ? (winWidth.width - gv.max_width_var) / 2 + 20
                  : 20,
            }}
            onClick={() => {
              setIsOpenCall(!isOpenCall);
            }}
          >
            <HeadphoneIcon
              width="32px"
              height="32px"
              className="call-icon "
              color={colorsSchema.schema_surface_main}
            />
          </div>
          <Drawer
            isOpen={isOpenCall}
            onClose={() => setIsOpenCall(false)}
            height={90}
          >
            <div className="demo-content ">
              <div className="parent-drawer d-flex justify-content-evenly align-items-center">
                <div className="demo-content text-center mr-t-20 title-h3-m d-flex align-items-center">
                  <IoIosCall className="mr-x-4 call-icon-mirror" />
                  <span> 021-91691584</span>
                </div>
                <div className="text-center">
                  {" "}
                  <CustomButton
                    className="mr-t-20 mr-b-10 "
                    buttonStyle="primary"
                    state="default"
                    size="medium"
                    onClick={() => {
                      setIsOpenCall(false);
                    }}
                  >
                    <CloseIcon
                      color={`${colorsSchema.schema_background_main}`}
                    />
                    <span>انصراف</span>
                  </CustomButton>
                </div>
              </div>
            </div>
          </Drawer>
        </div>
      );
    } else {
      return (
        <a href="tel:0214456789" className="profile-link">
          <div
            className="call pd-12 "
            style={{
              cursor: "pointer",
              left:
                winWidth.width > 600
                  ? (winWidth.width - gv.max_width_var) / 2 + 20
                  : 20,
            }}
            onClick={() => {
              setIsOpenCall(!isOpenCall);
            }}
          >
            <HeadphoneIcon
              width="32px"
              height="32px"
              className="call-icon "
              color={colorsSchema.schema_surface_main}
            />
          </div>
          {/* <div>
             <ProfileItem
                title={object.title}
                description={object.description}
                mainIcon={object.mainIcon}
                moreIcon={<ArrowLeftIcon />}
              />
            </div> */}
        </a>
      );
    }
  };
  useEffect(() => {
    winWidth.height > 680 ? setHeight(627) : setHeight("85%");
  }, [winWidth]);
  const addMToTimestamp = (timestamp, addMinutes) => {
    const date = new DateObject({ date: timestamp });
    date.add(addMinutes, "minutes");
    return TimeStampToJalali(date, "HH:mm");
  };

  const [boxBanners, setBoxBanners] = useState({});

  useEffect(() => {
    const loadBanner = async () =>
      setBoxBanners(await getBoxByPosition("a1,a2,a3"));
    loadBanner();
  }, []);

  return loading ? (
    <div className="d-flex align-items-center justify-content-center h-100">
      <Loader width={40} />
    </div>
  ) : (
    <div className=" shoplist-style d-flex flex-column h-100">
      <div>{supportCalls()}</div>
      <div className="pd-x-20">
        {boxBanners.a1 && <BoxSlider banner={boxBanners.a1} />}

        <div className="d-flex align-items-center">
          <div className="d-flex align-items-center w-100">
            <div className="sabadi-icon-style mr-t-12 mr-l-8 pd-4">
              <SabadiIcon className="mr-x-auto" />
            </div>
            {auth.isLogin == false ? (
              <WithLogin buttonStyle="text" className="pd-0 mr-0">
                <div className="d-flex align-items-center address-select pd-y-4 mr-t-16">
                  <p className="mr-r-6 txt-t2-m">ابتدا آدرس را انتخاب کنید</p>
                  <ArrowDownIcon
                    style={{ width: 16, height: 16 }}
                    color={colorsSchema.foreground_negative_me}
                    iconClassName="fw-bolder mr-x-4"
                  />
                </div>
              </WithLogin>
            ) : defaultAddress?.length == 0 ? (
              <div
                onClick={() => {
                  setIsOpen(true);
                }}
                className=" hover-div d-flex align-items-center address-select pd-y-4 mr-t-16"
                style={{ lineHeight: "21px" }}
              >
                <p className="mr-r-6 txt-t2-m">ابتدا آدرس را انتخاب کنید</p>
                <ArrowDownIcon
                  style={{ width: 16, height: 16, fontWeight: "bold" }}
                  color={colorsSchema.foreground_negative_me}
                  iconClassName="fw-bolder mr-x-4"
                />
              </div>
            ) : (
              <div className="mr-t-6 flex-grow-1 ">
                {" "}
                <div className="address-title2 d-flex">
                  <div
                    className="hover-div d-flex align-items-center address-title1 pd-y-4"
                    style={{ lineHeight: "21px" }}
                    onClick={() => {
                      setIsOpen(true);
                    }}
                  >
                    <h6 className="address-title txt-t2-m pd-r-6">
                      {defaultAddress[0]?.title}
                    </h6>

                    <ArrowDownIcon
                      style={{ width: 16, height: 16 }}
                      iconClassName=" mr-x-4 "
                    />
                  </div>
                </div>
                <div style={{ maxWidth: 123 }}>
                  <p
                    className="address-desc desc-l mr-t-4"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setIsOpen(true);
                      // setAllDiv(
                      //   document
                      //     .getElementById("drawer-container")
                      //     .getElementsByTagName("div")
                      // );
                    }}
                  >
                    {defaultAddress[0]?.address}
                  </p>
                </div>
              </div>
            )}
          </div>
          {auth.isLogin == false && (
            <WithLogin
              buttonStyle="text"
              className="txt-t3-m mr-t-20 mr-0 pd-0 "
              style={{ whiteSpace: "nowrap" }}
            >
              ورود به سبدی
            </WithLogin>
          )}
        </div>

        {boxBanners.a2 && <BoxSlider banner={boxBanners.a2} />}

        <div className="mr-t-16">
          <WithSearch
            placeholder="جستجو در سبدی"
            haveIcon
            style={{ backgroundColor: "#F3F4F6cc" }}
          />
        </div>

        {boxBanners.a3 && <BoxSlider banner={boxBanners.a3} />}

        <div className="box-carousel"></div>
        {/* <div className="mr-t-16" style={{borderRadius: "10px"}}>
                    <Swiper
                        modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                        slidesPerView={1}
                        autoplay={{delay: 6000}} // navigation
                        pagination={{clickable: true}}
                        // onSwiper={(swiper) => console.log(swiper)}
                        // onSlideChange={() => console.log("slide change")}
                    >
                        {slideImg.length > 0 &&
                            slideImg.map((val, ind) => {
                                return (
                                    <div style={{borderRadius: "6px"}}>
                                        <SwiperSlide>
                                            <div>
                                                <img
                                                    style={{
                                                        width: "100%",
                                                        borderRadius: "6px",
                                                    }}
                                                    src={pathMaker(val.path)}
                                                ></img>
                                            </div>
                                        </SwiperSlide>
                                    </div>
                                );
                            })}
                    </Swiper>
                </div> */}
      </div>

      {/* <div className="d-flex mr-x-20 mr-t-20 mr-b-24">
        {cats?.map((value, index) => {
          return (
            <div
              key={`cat_${index}`}
              className="mr-l-12"
              style={{
                cursor: index == 0 && "pointer",
              }}
              // onClick={() => {
              //   changeCat(value.index);
              // }}
            >
              {value.cover != undefined ? (
                <img
                  src={loadImg ? defaultCover : pathMaker(value.cover?.path)}
                  onLoad={() => setLoadImg(false)}
                  // src={pathMaker(value.cover.path)}
                  style={{
                    width: 72,
                    height: 72,
                    borderRadius: 6,
                    border:
                      selectedCat == value.index &&
                      `1px solid ${colorsSchema.schema_primary_main}`,
                  }}
                />
              ) : (
                <img
                  src={defaultCover}
                  style={{
                    width: 72,
                    height: 72,
                    borderRadius: 6,
                    border:
                      selectedCat == value.index &&
                      `1px solid ${colorsSchema.schema_primary_main}`,
                  }}
                />
              )}
              <h3
                className="title-h5-m text-center mr-t-6"
                style={{ color: colorsSchema.foreground_background_he }}
              >
                {value.name}
              </h3>
            </div>
          );
        })}
      </div> */}

      {orders?.reverse().map((value, index) => {
        return (
          <div className="mr-x-20">
            <div
              className="d-flex justify-content-between pd-12"
              style={{
                backgroundColor: colorsSchema.schema_surface_light,
                border: `1px solid ${colorsSchema.foreground_outline_darker}`,
                height: 77,
                borderRadius: 6,
                marginTop: index != "0" && "12px",
              }}
            >
              <div>
                <p
                  className="title-h5-m"
                  style={{ color: colorsSchema.foreground_background_he }}
                >
                  در حال آماده سازی
                </p>
                <h6
                  className="desc-c-l mr-t-12"
                  style={{ color: colorsSchema.foreground_background_me }}
                >
                  {value.suplier_info.title}
                </h6>
              </div>
              <div>
                <div
                  className="desc-l mr-t-12"
                  style={{ color: colorsSchema.foreground_background_me }}
                >
                  تحویل تا
                </div>
                <h6
                  className="title-h5-m mr-t-4 text-end"
                  style={{ color: colorsSchema.foreground_background_he }}
                >
                  {addMToTimestamp(
                    parseInt(value.mtm * 1000),
                    parseInt(value.suplier_info.send_in_time)
                  )}
                </h6>
              </div>
            </div>
          </div>
        );
      })}
      <div className="mr-t-24">
        {shopItemOk.length > 0 || shopItemNok.length > 0 ? (
          <>
            {shopItemOk?.map((value, index) => {
              return (
                <div className="">
                  <ShopItem
                    key={`shop_${index}`}
                    shopId={value.info.suppliers__id}
                    shopName={value.info.title}
                    shopImageCover={value.cover[0]?.path}
                    shopImageInfo={value.info.path}
                    shipping_cost={value.info.send_in_cost}
                    start_hour={value.info.start_hour}
                    start_min={value.info.start_min}
                    finish_hour={value.info.finish_hour}
                    finish_min={value.info.finish_min}
                    latShop="2"
                    langShop="2"
                    radiusShop="4"
                    // latShop={value.info.lat}
                    // langShop={value.info.lang}
                    // radiusShop={value.info.radius}
                    defaultAddress={defaultAddress}
                    main_status={value.info.main_status}
                    updater={updater}
                    updateAddress={updateAddress}
                    inventory={value.inventory}
                  />
                </div>
              );
            })}
            {shopItemNok?.map((value, index) => {
              return (
                <div className="">
                  <ShopItem
                    key={`shop_${index}`}
                    shopId={value.info.suppliers__id}
                    shopName={value.info.title}
                    shopImageCover={
                      value?.cover != undefined && value?.cover[0] != undefined
                        ? value?.cover[0]?.path
                        : ""
                    }
                    shopImageInfo={value.info.path}
                    shipping_cost={value.info.send_in_cost}
                    start_hour={value.info.start_hour}
                    start_min={value.info.start_min}
                    finish_hour={value.info.finish_hour}
                    finish_min={value.info.finish_min}
                    latShop="2"
                    langShop="2"
                    radiusShop="4"
                    defaultAddress={defaultAddress}
                    main_status={value.info.main_status}
                    updater={updater}
                    updateAddress={updateAddress}
                    inventory={value.inventory}
                  />
                </div>
              );
            })}
          </>
        ) : (
          <div className="d-flex justify-content-center align-items-center text-center flex-grow-1">
            <div>
              {/* <div
              style={{
                width: "149px",
                height: "119px",
                backgroundColor: "#d9d9d9",
                margin: "auto"
              }}
            ></div> */}
              <div className="desc-c-l text-center" style={{ width: "238px" }}>
                فروشگاهی در محدوده آدرس شما وجود ندارد. به زودی در اینجا
                فروشگاههایی در دسترس خواهند بود.
              </div>
            </div>
          </div>
        )}
      </div>
      <Drawer
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        height={
          // winWidth.height > heightDiv && auth.userInfo.addresses.length < 8
          558.6 < auth.userInfo.addresses.length * 61 + 195
            ? "558.6px"
            : auth.userInfo.addresses.length * 61 + 195

          // 601
        }
      >
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ height: 48 }}
        >
          <div className="mr-r-20 d-flex align-items-center">
            <NavLink to="/user-profile">{/* <ArrowRightIcon /> */}</NavLink>

            <span className="mr-r-8 title-h3-b">انتخاب آدرس </span>
          </div>
          <div>
            <button
              onClick={() => {
                setIsOpenDrawer(true);
              }}
              className="btn title-h5-m d-flex mr-l-8 border-0"
            >
              <AddIcon width="20px" height="20px" />
              <span className="mr-r-4">افزودن</span>
            </button>
          </div>
        </div>
        <div className="mr-x-20">
          <CustomInput
            title=""
            placeholder="جستجو محله در گرگان"
            value={titleData}
            onChange={(e) => setTitleData(e.target.value)}
            messageText={titleError}
            containerClassName="mr-b-32"
            labelClassName="pd-b-4"
            textType={titleError.length === 0 ? "none" : "error"}
            haveIcon={true}
            onClick={(e) => {
              e.target.blur();
              setIsOpenDrawer(true);
            }}
          />
        </div>
        <div className=" pd-x-20">
          {auth.userInfo.addresses.map((item, index) => (
            <>
              <AddressItem
                key={`address_${index}`}
                id={item.id}
                title={item.title}
                address={item.address}
                selected={item.id == selectedId ? true : false}
                RadioBtnFunc={(id) => {
                  EditAddressFunc(id);
                  setSelectedId(id);
                }}
                hasRadioBtn={true}
                item={item}
                updateAddress={updateAddress}
              />
              {index != auth.userInfo.addresses.length - 1 && (
                <div className="mr-y-16 separator-line" />
              )}
            </>
          ))}
        </div>
      </Drawer>
      <Drawer
        isOpen={isOpenDrawer}
        onClose={() => setIsOpenDrawer(false)}
        height={height}
      >
        <div className="demo-content pd-x-20">
          <Add
            setHeight={setHeight}
            setIsOpen2={setIsOpenDrawer}
            setUpdaterAddress={setUpdaterAddress}
          />
        </div>
      </Drawer>
    </div>
  );
}
